import { render } from "./BaseBarChart.vue?vue&type=template&id=39b16a9b&scoped=true"
import script from "./BaseBarChart.vue?vue&type=script&lang=js"
export * from "./BaseBarChart.vue?vue&type=script&lang=js"

import "./BaseBarChart.vue?vue&type=style&index=0&id=39b16a9b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b16a9b"]])

export default __exports__